import React from "react";
import { connect } from "react-redux";
import { NavLink, Link } from "react-router-dom";
import { Nav } from "reactstrap";
import { withTranslation } from "react-i18next";
import themeDetails from "../../getThemeDetails";
import constants from "../../config/constants";
import MenuIcon from "@mui/icons-material/Menu"
// import MenuIcon from "@mui/icons-material/Menu";
import SubMenu from "./SubMenu";
import paymentzLogo from "../../assets/img/paymentz-icon.png";
// import sidebarRoute from "../../routes/subRoute";

const val = themeDetails;
// var plogo = "";
// if (val.theme === "default") {
// plogo = require("../../assets/img/sidebar/" + val.theme + "_icon.png");
// }
const logo = require("../../assets/img/sidebar/" + val.theme + ".png");

// const logo = `${process.env.PUBLIC_URL}/${themeDetails.theme}/${themeDetails.theme}.png`;

// console.log(logo);

class Sidebar extends React.Component {
	constructor(props) {
		super(props);
		this.activeRoute.bind(this);
		this.state = {
			navStatus: true
		};
	}

	// verifies if routeName is the one active (in browser input)
	activeRoute(routeName) {
		return this.props.location.pathname.indexOf(routeName) > -1 ? "active" : "";
	}
	// componentDidMount() {
	//   if (navigator.platform.indexOf("Win") > -1) {
	//     ps = new PerfectScrollbar(this.refs.sidebar, {
	//       suppressScrollX: true,
	//       suppressScrollY: false
	//     });
	//   }
	// }
	// componentWillUnmount() {
	//   if (navigator.platform.indexOf("Win") > -1) {
	//     ps.destroy();
	//   }
	// }
	render() {
		const currentTheme = this.props.theme?.theme;
		let plogo = "";
		if (currentTheme && currentTheme.includes("Dark")) {
			plogo = require("../../assets/img/sidebar/" + val.theme + "_iconDark.png");
		} else if (val.theme === "default") {
			plogo = require("../../assets/img/sidebar/" + val.theme + "_icon.png");
		} else if (val.theme === "dreamzwallet") {
			plogo = require("../../assets/img/sidebar/dreamzwallet_icon.png");
		} else {
			plogo = require("../../assets/img/sidebar/" + val.theme + "_icon.png");
		}
		const {
			t,
			bgColor,
			activeColor,
			routes,
			service,
			login: {
				data: {
					accountType,
					isPrepaidCardFeatureRequired,
					isCustCreationAllowed,
					Logo
				}
			},
			walletSetting: {
				data: {
					isLoyaltyPointsAllowed,
					isActivityLogAllowed,
					isTransactionHistory,
					isWalletHistory,
					isBillPayment
				}
			}
		} = this.props;

		const { visibleFlags } = constants;

		const isTransactionOptionEnabled = () => {
			return (
				visibleFlags.includes(isTransactionHistory) &&
				visibleFlags.includes(isWalletHistory)
			);
		};
		const navFunc = () => {
			if (this.state.navStatus == false) {
				this.setState({ navStatus: true });
			} else {
				this.setState({ navStatus: false });
			}
			this.props.parentCallback(this.state.navStatus);
			// console.log(this.state.navStatus, "/////////////////");
		};
		console.log("sidebarRoute", this.props.sidebarRoute);

		return (
			<div
				className="sidebar"
				style={{
					width: this.state.navStatus ? "260px" : "80px"
				}}
				data-color={bgColor}
				data-active-color={activeColor}
			>
				{/* <div className="logo">
          {plogo && (
            <Link
              to={{
                pathname: "/",
                //pathname: "/index/dashboard",
                search: `?walletOwnerId=${val.walletOwnerId}`,
              }}
              className="simple-text logo-mini"
            >
              <img className="logo-icon" src={plogo} alt="react-p-logo" />
            </Link>
          )}
          <Link
            to={{
              pathname: "/",
              //pathname: "/index/dashboard",
              search: `?walletOwnerId=${val.walletOwnerId}`,
            }}
            className="simple-text logo-normal"
          >
            <div className="logo-img pz-logo">
              <img
                src={logo}
                alt="react-logo"
                style={{ height: "100%", width: "150px" }}
              />
            </div>
          </Link>
        </div> */}
				<div className="logo">
					{plogo && (
						<>
							{this.state.navStatus && (
								<Link
									to={{
										pathname: "/",
										//pathname: "/index/dashboard",
										search: `?walletOwnerId=${val.walletOwnerId}`
									}}
									className=""
								>
									<img
										className="mainLogo"
										style={{ height: "2.8", width: "13rem" }}
										src={
											this.props.login.data.LoginName == "paymentz"
												? paymentzLogo
												: plogo
										}
										alt="react-p-logo"
									/>
								</Link>
							)}
							<MenuIcon style={{ cursor: "pointer" }} onClick={navFunc} />
							{/* <h1>Hello</h1> */}
							{/* <div style={{ display: "flex", paddingBottom: "15px", paddingTop: "15px" }}>
								<img
									src={`data:image/jpeg;base64,${this.props.login.data.Icon}`}
									style={{ maxWidth: "30%" }}
								/>
								<div style={{ marginTop: "auto", paddingLeft: "10px", textAlign: "left", fontSize: "13px", marginBottom: "auto" }}>
									<h6>Wallet Owner Id : {this.props.login.data.partnerId}</h6>
									<h6>User : {this.props.login.data.Name}</h6>
								</div>

							</div> */}
						</>
					)}
					{/* <Link
  to={{
    pathname: "/",
    //pathname: "/index/dashboard",
    search: `?walletOwnerId=${val.walletOwnerId}`,
  }}
  className="simple-text logo-normal"
>
  <div className="logo-img pz-logo">
    <img
      src={logo}
      alt="react-logo"
      style={{ height: "100%", width: "150px" }}
    />
  </div>
</Link> */}
				</div>

				<div
					className="sidebar-wrapper"
					ref="sidebar"
					style={{
						width: this.state.navStatus ? "" : "unset"
					}}
				>
					<div style={{ display: "flex", padding: "15px" }}>
						{this.props.login?.data?.subRole !== "SubOwner" && (
						<img
							src={`data:image/jpeg;base64,${this.props.login.data.Icon}`}
							style={{ maxWidth: this.state.navStatus ? "30%" : "100%" }}
						/>)}
						{this.state.navStatus && (
							<div
								style={{
									marginTop: "auto",
									paddingLeft: "15px",
									textAlign: "left",
									fontSize: "12px",
									marginBottom: "auto"
								}}
							>
								<h6>  Owner Id : {
									this.props.login?.data?.subRole === "SubOwner"
										? this.props.login?.data?.parentId
										: this.props.login?.data?.partnerId
								}</h6>
								<h6>{this.props.login.data.Name}</h6>
							</div>
						)}
					</div>

					<Nav>
						{this.props.sidebarRoute.data.map((prop, key) => {
							return (
								// <>
								// <h6>hello</h6>
								// </>
								<SubMenu
									{...prop}
									key={key}
									service={service}
									navStatus={this.state.navStatus}
									handlepath={this.props.handlepath}
								/>
							);
						})}
					</Nav>
				</div>
			</div>
		);
	}
}

const mapStateToProps = (state) => ({


	login: state.login,
	walletSetting: state.walletSetting,
	sidebarRoute: state.sidebarRoute,
	theme: state.theme
});

export default connect(mapStateToProps, null)(withTranslation()(Sidebar));
